export const hdmgdjRankingCategories = [
  { id: "all", name: "全部方向" },
  { id: "city", name: "都市现代" },
  { id: "ancient", name: "国风古装" },
  { id: "rebirth", name: "穿越重生" },
  { id: "mystery", name: "悬疑烧脑" },
];

export const hdmgdjRankingList = [
  {
    id: "r-1",
    rank: 1,
    title: "重生之我成了首富",
    category: "rebirth",
    categoryName: "穿越重生",
    tag: "大神精选",
    heat: "49.2万",
    cover: "/images/genre-city.jpg",
  },
  {
    id: "r-2",
    rank: 2,
    title: "大小姐的反击计划",
    category: "city",
    categoryName: "都市现代",
    tag: "全2季",
    heat: "46.8万",
    cover: "/images/genre-romance.jpg",
  },
  {
    id: "r-3",
    rank: 3,
    title: "一梦千年入宫闱",
    category: "ancient",
    categoryName: "国风古装",
    tag: "大神精选",
    heat: "43.5万",
    cover: "/images/genre-ancient.jpg",
  },
  {
    id: "r-4",
    rank: 4,
    title: "穿书后我成了团宠",
    category: "rebirth",
    categoryName: "穿越重生",
    tag: "全1季",
    heat: "41.9万",
    cover: "/images/genre-fantasy.jpg",
  },
  {
    id: "r-5",
    rank: 5,
    title: "深夜来电三十秒",
    category: "mystery",
    categoryName: "悬疑烧脑",
    tag: "全1季",
    heat: "38.6万",
    cover: "/images/genre-mystery.jpg",
  },
  {
    id: "r-6",
    rank: 6,
    title: "老板今天也很正常",
    category: "city",
    categoryName: "都市现代",
    tag: "爆笑",
    heat: "35.2万",
    cover: "/images/genre-comedy.jpg",
  },
  {
    id: "r-7",
    rank: 7,
    title: "凤鸣九霄录",
    category: "ancient",
    categoryName: "国风古装",
    tag: "大神精选",
    heat: "33.7万",
    cover: "/images/genre-ancient.jpg",
  },
  {
    id: "r-8",
    rank: 8,
    title: "第十二封遗书",
    category: "mystery",
    categoryName: "悬疑烧脑",
    tag: "全3季",
    heat: "31.4万",
    cover: "/images/genre-mystery.jpg",
  },
  {
    id: "r-9",
    rank: 9,
    title: "在都市里开一家小店",
    category: "city",
    categoryName: "都市现代",
    tag: "治愈",
    heat: "29.8万",
    cover: "/images/genre-city.jpg",
  },
];